import ReactApexChart from "react-apexcharts";

function LeadsBySource({ sourceChart = [] }) {
  return (
    <ReactApexChart
      options={{
        labels: sourceChart.map((item) => item.label),
        colors: sourceChart.map((item) => item.color),
        chart: {
          type: "donut",
          height: 180,
          fontFamily: "Inter, sans-serif",
        },
        plotOptions: {
          pie: {
            donut: {
              size: "70%",
              labels: {
                show: true,
                total: {
                  show: true,
                  label: "Sources",
                  fontSize: "14px",
                  fontWeight: 600,
                  color: "#6B7280",
                },
                value: {
                  fontSize: "24px",
                  fontWeight: 700,
                  color: "#111827",
                },
              },
            },
          },
        },
        dataLabels: {
          enabled: false,
        },
        legend: {
          show: true,
          position: "right",
          fontSize: "12px",
          fontWeight: 500,
          labels: {
            colors: "#6B7280",
          },
          markers: {
            width: 8,
            height: 8,
            radius: 2,
          },
          itemMargin: {
            horizontal: 10,
            vertical: 5,
          },
        },
        tooltip: {
          theme: "light",
        },
      }}
      series={sourceChart.map((item) => item.value)}
      type="donut"
      height={180}
    />
  );
}

export default LeadsBySource;